import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Center,
  Checkbox,
  CheckboxGroup,
  Divider,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  search,
  setDateFrom,
  setDateTo,
  setSearchFields,
  setSources,
  setcollapseResults,
} from "../store/search";
import { fields, sources } from "../utils";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../config";

export const Filters = () => {
  const selectedSearchFields = useSelector((s) => s.searchSlice.searchFields);
  const selectedSources = useSelector((s) => s.searchSlice.sources);
  const dateFrom = useSelector((s) => s.searchSlice.date_from);
  const dateTo = useSelector((s) => s.searchSlice.date_to);
  const collapseResults = useSelector((s) => s.searchSlice.collapseResults);
  const source_aggs =
    useSelector((s) => s.searchSlice.searchResults).source_aggs || {};

  const dispatch = useDispatch();

  return (
    <Box color={"yellow.200"}>
      <Center>
        <Text fontSize={"3xl"} fontWeight={"bold"}>
          Filters
        </Text>
      </Center>
      <Divider mt={10} mb={10} />
      <div>
        <Checkbox
          onChange={(e) => {
            dispatch(setcollapseResults({ collapseResults: e.target.checked }));
            dispatch(search());
          }}
          defaultChecked={collapseResults}
          value="collapse_hits"
          colorScheme="yellow"
        >
          Collapse Search Hits
        </Checkbox>
      </div>
      <Divider mt={10} mb={10} />
      <div>
        <Center>
          <Text fontSize={"2xl"} fontWeight={"bold"} my={3}>
            Search In
          </Text>
        </Center>
        <CheckboxGroup
          onChange={(e) => {
            dispatch(setSearchFields({ searchFields: e }));
            dispatch(search());
          }}
          colorScheme="yellow"
          defaultValue={selectedSearchFields}
        >
          <Stack spacing={[1]} direction={["column"]}>
            {fields.map((f) => (
              <Checkbox value={f.value}>{f.label}</Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
      </div>
      <Divider mt={10} mb={10} />
      <div>
        <Center>
          <Text fontSize={"2xl"} my={3} fontWeight={"bold"}>
            Sources
          </Text>
        </Center>
        <CheckboxGroup
          onChange={(e) => {
            dispatch(setSources({ sources: e }));
            dispatch(search());
          }}
          colorScheme="yellow"
          defaultValue={selectedSources}
        >
          <Stack spacing={[1]} direction={["column"]}>
            {sources.map((s) => (
              <Checkbox value={s.value}>
                {s.label} ({source_aggs[s.value] || 0})
              </Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
      </div>
      <Divider mt={10} mb={10} />
      <Center>
        <Text color={"yellow.200"} fontSize={"2xl"}>
          Date range
        </Text>
      </Center>
      <Box>
        <Text fontSize={"lg"} mb={2}>
          {" "}
          From{" "}
        </Text>
        <input
          defaultValue={dateFrom}
          onChange={(e) => {
            dispatch(setDateFrom({ date_from: e.target.value }));
            dispatch(search());
          }}
          style={{ padding: "4px", color: "gray" }}
          type="date"
        />
        <Text fontSize={"lg"} my={8} mb={2}>
          {" "}
          To{" "}
        </Text>
        <input
          defaultValue={dateTo}
          onChange={(e) => {
            dispatch(setDateTo({ date_to: e.target.value }));
            dispatch(search());
          }}
          style={{ padding: "4px", color: "gray" }}
          type="date"
        />
      </Box>
    </Box>
  );
};
